/**
 * Sorgt dafür, dass unterhalb eines Feldes genug Platz für seine
 * Vorschlagsliste sichtbar ist.
 *
 * Hintergrund: Die Fokusführung scrollt mit `block: 'nearest'` – das bringt ein
 * Feld gerade so ins Bild, es steht dann aber am unteren Rand. Googles
 * Adressvorschläge klappen darunter auf und liegen damit außerhalb des
 * sichtbaren Bereichs. Betroffen ist vor allem die Zieladresse, die im großen
 * Formular weit unten sitzt.
 *
 * Gescrollt wird nur, wenn der Platz tatsächlich fehlt – sonst springt die
 * Ansicht bei jedem Feldwechsel ohne Grund.
 */

// Ungefähre Höhe der Vorschlagsliste (rund fünf Einträge).
const DEFAULT_MIN_ROOM_PX = 280;

const isScrollable = (element) => {
  if (!element || element === document.body) return false;
  const style = window.getComputedStyle(element);
  return (
    /(auto|scroll|overlay)/.test(style.overflowY) &&
    element.scrollHeight > element.clientHeight
  );
};

/** Nächster scrollbarer Vorfahr – im Dialog der DialogContent, im Panel die Box. */
const findScrollContainer = (element) => {
  let parent = element?.parentElement;
  while (parent) {
    if (isScrollable(parent)) return parent;
    parent = parent.parentElement;
  }
  return null;
};

export const ensureRoomBelow = (element, minRoom = DEFAULT_MIN_ROOM_PX) => {
  if (!element?.getBoundingClientRect) return;

  const rect = element.getBoundingClientRect();
  const container = findScrollContainer(element);
  const bottomEdge = container
    ? container.getBoundingClientRect().bottom
    : window.innerHeight;

  const roomBelow = bottomEdge - rect.bottom;
  if (roomBelow >= minRoom) return;

  // `center` statt `nearest`: Das schafft in einem scrollbaren Bereich den
  // größtmöglichen Platz nach unten. Reicht die Höhe des Bereichs nicht aus,
  // ist das immer noch das beste erreichbare Ergebnis.
  element.scrollIntoView({ block: 'center', behavior: 'smooth' });
};

export default ensureRoomBelow;
